module.exports = __webpack_public_path__ + "__static/site-1747751661846/img/products-carousel-kids.2ac5e020.png";